import { H1 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

type Props = {
    callToAction?: React.ReactNode;
    className?: string;
    title: React.ReactNode;
};

const PageTitle = ({ callToAction, className, title }: Props) => {
    if (!title) {
        return null;
    }
    return (
        <StyledTitle>
            <H1
                className={`${className ?? ''} mb-md mt-lg block`}
                data-testid="pageTitle"
            >
                {title}
            </H1>
            {Boolean(callToAction) && <StyledCallToAction>{callToAction}</StyledCallToAction>}
        </StyledTitle>
    );
};

export default React.memo<Props>(PageTitle, isEqual);

const StyledTitle = styled.section`
    display: flex;
    justify-content: space-between;
`;

const StyledCallToAction = styled.span`
    margin: 64px 0 0;
`;
